// extracted by mini-css-extract-plugin
export default {"testsContainer":"testsContainer-VhhyV","buttonsContainer":"buttonsContainer-XknIz","modal":"modal-g9BzU","addMoreTests":"addMoreTests-a9txy"};